import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { style: {"font-weight":"bold"} }
const _hoisted_3 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ServiceRow = _resolveComponent("ServiceRow")!

  return (_openBlock(), _createBlock(_component_v_col, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { sm: "10" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", {
            textContent: _toDisplayString(_ctx.$t('einstellungen.service.title'))
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "pl-5",
            sm: "10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "borderbottom tableheader" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    sm: "8",
                    class: "py-0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.service.table.service')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    sm: "2",
                    class: "py-0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.service.table.speicherlimite')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    sm: "2",
                    class: "py-0",
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.service.table.cost') + '/' + _ctx.$t('einstellungen.service.table.month')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ServiceRow, {
                service: _ctx.teilnehmerService.basisService
              }, null, 8, ["service"]),
              (_ctx.teilnehmerService.funktionService)
                ? (_openBlock(), _createBlock(_component_ServiceRow, {
                    key: 0,
                    service: _ctx.teilnehmerService.funktionService
                  }, null, 8, ["service"]))
                : _createCommentVNode("", true),
              (_ctx.teilnehmerService.speicherService)
                ? (_openBlock(), _createBlock(_component_ServiceRow, {
                    key: 1,
                    service: _ctx.teilnehmerService.speicherService
                  }, null, 8, ["service"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, { class: "borderbottom" }, {
                default: _withCtx(() => [
                  (_ctx.teilnehmerService.speicherService != null && _ctx.verrechnung != null)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        sm: "8",
                        class: "py-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('einstellungen.service.table.total')), 1),
                          _createTextVNode(" (" + _toDisplayString(_ctx.$t('einstellungen.service.table.ablaufdatum')) + " " + _toDisplayString(_ctx.verrechnung.verrechnungBis) + ") ", 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        sm: "8",
                        class: "py-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('einstellungen.service.table.total')), 1)
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_v_col, {
                    sm: "2",
                    class: "py-0"
                  }),
                  _createVNode(_component_v_col, {
                    sm: "2",
                    class: "py-0",
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.calculatePreisProMonat()), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}